import { Radio } from 'ui/radio';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const StyledRadioListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledRadio = styled(Radio)`
  display: inline-flex;
  min-width: ${pxToRem(18)};
  max-width: ${pxToRem(18)};
`;
